export var attachScriptToHTML = function (content, scriptType, callback) {
    var script = document.createElement('script');
    script.type = scriptType;
    switch (scriptType) {
        case "module" /* Module */:
            script.textContent = content;
            break;
        case "text/javascript" /* Text */:
            script.src = content;
            break;
        default:
            break;
    }
    if (callback) {
        script.onload = function () { return callback(); };
    }
    document.head.appendChild(script);
};
